import React, { useEffect } from 'react';
import { useAiRovoCurrentRouteConfiguration } from '@jira/ai-rovo_actions-store/src/useAiRovoCurrentRouteConfiguration.tsx';
import { AISmartButtonRefresh } from '@atlassian/ai-smart-button';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useConversationAssistantSidebarApi } from '@atlassian/jira-conversation-assistant/src/ui/useConversationAssistantSidebarApi.tsx';
import { useSourceAIActions } from '@atlassian/ai-smart-button-api';

export const AiRovoButtonWrapperRefresh = (): React.JSX.Element => {
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();
	const configuration = useAiRovoCurrentRouteConfiguration();
	const sidebarApi = useConversationAssistantSidebarApi({});
	const { setNudges } = useSourceAIActions('jira-ai-rovo-button');

	useEffect(() => {
		setNudges(configuration.nudges ?? []);
	}, [configuration.nudges, setNudges]);

	return (
		<AISmartButtonRefresh
			product="jira"
			cloudId={cloudId}
			orgId={orgId}
			isNav4Enabled
			sidebarApi={sidebarApi}
			productPage="jira"
			getActions={configuration.getActions}
		/>
	);
};
